import { ScoringHandler } from "@/dataprocessor/scoring";
import { FBPixelSDK } from "@/providers/retargeting-plugs/plugs/fbpixel";
import { Product } from "@/ui-sdk/types";

interface ProductView {
  content_ids: string[];
  content_type: string;
  value: number;
  currency: string;
  content_name: string;
}

function getTopProducts() {
  const productHandlesAndScores =
    ScoringHandler.Product.getComputedProductScores();

  const sortedProductHandles = Object.entries(productHandlesAndScores).sort(
    ([, score], [, otherScore]) => otherScore - score,
  );

  const viewedTopProductHandles = sortedProductHandles.map(
    ([handle]) => handle,
  );

  const similarTopProductHandles = viewedTopProductHandles.map((handle) => {
    return (
      ((window.helium.datastore.memory?.product?.[handle]?.similar ?? []).at(
        0,
      ) as string) ?? null
    );
  });

  const allProducts = similarTopProductHandles
    .map((e) => window.helium.datastore.memory?.product?.[e]?.details)
    .filter(Boolean) as Product[];

  return allProducts.map((e) => transformProductToPixelFormat(e));
}

export function transformProductToPixelFormat(product: Product): ProductView {
  return {
    content_ids: [product.shopifyId],
    content_type: "product",
    content_name: product.title,
    value: product.priceRange.maxVariantPrice.amount,
    currency: product.priceRange.maxVariantPrice.currencyCode,
  };
}

export function flushProductViewEvents() {
  const productViews = getTopProducts();

  productViews.slice(0, 5).forEach((productView) => {
    FBPixelSDK.track("track", "ViewContent", productView);
  });
}
